export const BASE_URL = import.meta.env.VITE_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://feesurvey.lcp.com');
export const GTM_ID = 'GTM-THXBBVJ7';
export const LCP_ORG_URL = 'https://www.lcp.com';

// Feature flags
export const PDF_DOWNLOAD_ENABLED = import.meta.env.VITE_PDF_DOWNLOAD_ENABLED === 'true';
